import { useSelector } from "react-redux";
import { useFormik } from "formik";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { TabView, TabPanel } from "primereact/tabview";
import { SelectButton } from "primereact/selectbutton";
import { useEffect, useState, useRef } from "react";
import ModalSeplag from "../../../components/ModalSeplag";
import CardSeplag from "../../../components/CardSeplag";
import { Button } from "primereact/button";
import RotuloSeplag from "../../../components/RotuloSeplag";
import { getFormErrorMessage, classNames, isFormFieldValid } from "../../../config/global";
import { atualizarExercicioRag, buscarQuestionarios, cadastraExercicioRag } from "../../../service/Rag/Exercicio";

const ModalRagExercicios = ({
  visible,
  setVisible,
  disabled,
  setDisabled,
  edit,
  setEdit,
  exercicio,
  exercicios,
  setAtualizarExercicio,
}) => {
  const [form, setForm] = useState([]);
  const [questionarios, setQuestionarios] = useState([]);
  const options = [
    { name: "Não", code: "N" },
    { name: "Sim", code: "S" },
  ];
  const toast = useRef(null);
  const user = useSelector((state) => state.userReducer.user);
  const sistema = user.contaAcesso.authorities.length > 0 ? user.contaAcesso.authorities[0].sistema.idenSistema : null;

  const startForm = () => {
    setForm({
      parametroexercicios: [],
      statParametroExercicio: 1,
      parametroexerciciosAnteriores: [],
      questionariosPrograma: [],
      questionarioProgramaCopia: null,
      questionarioIndicadorCopia: null,
      questionarioAcaoCopia: null,
      questionariosIndicador: [],
      questionariosAcao: [],
      visibleModalExercicio: false,
      questionarios: null,
      sistema: null,
      exercicio: null,
      flagAtivo: "N",
      flagFechadoEdicao: "N",
      selectedExercicio: null,
      checked: false,
      //simNao: simNao,
      totalRegistroQuestionario: 0,
      loadingPaginacaoQuestionario: false,
      urlPanagicaoQuestionario: "",
      maximoCaracteres: 4000,
      camposResultado: null,
    });
    if (edit || disabled) {
      setForm({
        ...exercicio,
      });
    }
  };

  const traduzSimNão = (elemento) => {
    if (typeof elemento === "string") {
      if (elemento === "Sim") return "S";
      if (elemento === "S") return "Sim";
      if (elemento === "Não") return "N";
      if (elemento === "N") return "Não";
      if (elemento === "Ativo") return "S";
      if (elemento === "Inativo") return "N";
    }
    return elemento;
  };

  const handleExit = () => {
    setVisible(false);
    setEdit(false);
    setDisabled(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: form,

    validate: (formData) => {
      let errors = {};
      if (!formData.exercicio) errors.exercicio = "Selecione o Exercício é Obrigatório";
      if (!formData.flagAtivo) errors.flagAtivo = "Data de Abertura é Obrigatório";
      if (!formData.flagFechadoEdicao) errors.flagFechadoEdicao = "Data de Fechamento é Obrigatório";
      return errors;
    },

    onSubmit: async (formData) => {
      if (!edit) {
        let exercicioRagPost = {
          idenParametroExercicio: null,
          exercicio: formData.exercicio,
          flagAtivo: formData.flagAtivo,
          flagFechadoEdicao: formData.flagFechadoEdicao,
          questionarioPrograma: formData.questionarioPrograma,
          questionarioIndicador: formData.questionarioIndicador,
          questionarioAcao: formData.questionarioAcao,
          statParametroExercicio: 1,
        };
        await cadastraExercicioRag(exercicioRagPost).then((_res) => {
          window.$toast.current.show({
            severity: "success",
            summary: "Ação Efetuada",
            detail: "Criado com Sucesso",
            life: 5000,
          });
          setVisible(false);
          setEdit(false);
          setDisabled(false);
          setAtualizarExercicio(true);
        });
      }

      if (edit) {
        let exercicioRagPut = {
          contaAcesso: formData.contaAcesso,
          cronograma: formData.cronograma,
          dataInclusao: formData.dataInclusao,
          exercicio: formData.exercicio,
          flagAtivo: formData.flagAtivo,
          flagFechadoEdicao: formData.flagFechadoEdicao,
          idenParametroExercicio: formData.idenParametroExercicio,
          questionarioAcao: formData.questionarioAcao,
          questionarioIndicador: formData.questionarioIndicador,
          questionarioPrograma: formData.questionarioPrograma,
          statParametroExercicio: formData.statParametroExercicio,
        };
        await atualizarExercicioRag(form.idenParametroExercicio, exercicioRagPut).then((_res) => {
          window.$toast.current.show({
            severity: "success",
            summary: "Ação Efetuada",
            detail: "Atualizado com Sucesso",
            life: 5000,
          });
          setVisible(false);
          setEdit(false);
          setDisabled(false);
          setAtualizarExercicio(true);
        });
      }
    },
  });

  useEffect(() => {
    if (sistema) {
      buscarQuestionarios(sistema).then((res) => {
        let data = res.data.map((elementos) => {
          return elementos.questionario;
        });
        setQuestionarios(data);
      });
    }
    startForm();
  }, []);

  return (
    <ModalSeplag
      titulo="Cadastrar/Habilitar Exercício"
      tamanho="1200px"
      type="NONE"
      visible={visible}
      fechar={handleExit}
    >
      <Toast ref={toast} />
      <TabView>
        <TabPanel header="Exercício" leftIcon="pi pi-user-edit">
          <CardSeplag>
            <form>
              <div className="field col-12 md:col-12 ">
                <div className="p-fluid grid">
                  <div className="field col-12 md:col-4">
                    <RotuloSeplag nome="Selecione o Exercício:" cols="12">
                      <Dropdown
                        disabled={disabled}
                        placeholder="Selecione o Exercício"
                        id="exercicio"
                        name="exercicio"
                        optionLabel="ano"
                        options={exercicios}
                        value={formik.values.exercicio}
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        virtualScrollerOptions={{ itemSize: 38 }}
                        className={"exercicio " + classNames({ "p-invalid": isFormFieldValid("exercicio", formik) })}
                      />
                      {getFormErrorMessage("exercicio", formik)}
                    </RotuloSeplag>
                  </div>
                  <div className="field col-12 md:col-4">
                    <RotuloSeplag nome="Sistema Ativo" cols="12 4">
                      <SelectButton
                        disabled={disabled}
                        options={options}
                        id="flagAtivo"
                        optionLabel="name"
                        optionValue="code"
                        value={formik.values.flagAtivo}
                        onChange={(e) => formik.handleChange(e)}
                      />
                      {getFormErrorMessage("flagAtivo", formik)}
                    </RotuloSeplag>
                  </div>
                  <div className="field col-12 md:col-4">
                    <RotuloSeplag nome="Sistema Fechado Edição" cols="12 4">
                      <SelectButton
                        disabled={disabled}
                        id="flagFechadoEdicao"
                        optionLabel="name"
                        optionValue="code"
                        options={options}
                        value={formik.values.flagFechadoEdicao}
                        onChange={(e) => formik.handleChange(e)}
                      />
                      {getFormErrorMessage("flagFechadoEdicao", formik)}
                    </RotuloSeplag>
                  </div>
                </div>
              </div>
            </form>
          </CardSeplag>
        </TabPanel>
        <TabPanel header="Questionário Programa" leftIcon="pi pi-user-edit">
          <card-seplag>
            {form.questionarioPrograma === null && (
              <label
                style={{
                  color: "red",
                  margin: "0",
                  width: "100%",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                Este exercicio não possui um questionário de programa associado
              </label>
            )}

            {form.parametroexerciciosAnteriores !== null && (
              <RotuloSeplag nome="Questionário do programa">
                <Dropdown
                  disabled={disabled}
                  placeholder="Selecione o Questionário"
                  id="questionarioPrograma"
                  name="questionarioPrograma"
                  optionLabel="descQuestionario"
                  value={formik.values.questionarioPrograma}
                  options={questionarios}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                />
              </RotuloSeplag>
            )}
          </card-seplag>
        </TabPanel>
        <TabPanel header="Questionário Indicador" leftIcon="pi pi-user-edit">
          <card-seplag>
            {form.questionarioIndicador === null && (
              <>
                <label
                  style={{
                    color: "red",
                    margin: "0",
                    width: "100%",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  Este exercicio não possui um questionário de indicador associado
                </label>
                <RotuloSeplag nome="Selecione um questionário para copiá-lo">
                  {form.parametroexerciciosAnteriores != null && (
                    <Dropdown
                      placeholder="Selecione o Questionário"
                      id="questionarioIndicadorCopia"
                      name="questionariosIndicador"
                      optionLabel="descQuestionario"
                      value={form.questionarioIndicadorCopia}
                      options={form.questionariosIndicador}
                      onChange={(e) => {
                        formik.handleChange(e);
                      }}
                    />
                  )}
                </RotuloSeplag>
              </>
            )}
            <RotuloSeplag nome="Questionário do programa">
              {form.parametroexerciciosAnteriores !== null && (
                <Dropdown
                  disabled={disabled}
                  placeholder="Selecione o Questionário"
                  id="questionarioIndicador"
                  name="questionarioIndicador"
                  optionLabel="descQuestionario"
                  value={formik.values.questionarioIndicador}
                  options={questionarios}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                />
              )}
            </RotuloSeplag>
          </card-seplag>
        </TabPanel>
        <TabPanel header="Questionário Ação" leftIcon="pi pi-user-edit">
          <card-seplag>
            {form.questionarioAcao === null && (
              <>
                <label style={{ color: "red", margin: "0", width: "100%", textAlign: "center", fontWeight: "bold" }}>
                  Este exercicio não possui um questionário de ação associado
                </label>
                <RotuloSeplag nome="Selecione um questionário para copiá-lo">
                  {form.parametroexerciciosAnteriores != null && (
                    <Dropdown optionLabel="descQuestionario" placeholder="Selecione o Questionário" />
                  )}
                </RotuloSeplag>
              </>
            )}
            <RotuloSeplag nome="Questionário do programa">
              {form.parametroexerciciosAnteriores !== null && (
                <Dropdown
                  disabled={disabled}
                  placeholder="Selecione o Questionário"
                  id="questionarioAcao"
                  name="questionarioAcao"
                  optionLabel="descQuestionario"
                  value={formik.values.questionarioAcao}
                  options={questionarios}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                />
              )}
            </RotuloSeplag>
          </card-seplag>
        </TabPanel>
      </TabView>
      {!disabled && (
        <div className="field col-12 md:col-12 ">
          <div className="p-fluid grid">
            <div className="field col-12 md:col-4 ">
              <Button label="Fechar" className="voltar p-button-danger" onClick={handleExit} />
            </div>

            <div className="field col-12 md:col-4">
              {!edit && <Button type="submit" label="Cadastrar" className="salvar" onClick={formik.handleSubmit} />}
              {edit && <Button type="submit" label="Salvar" className="salvar" onClick={formik.handleSubmit} />}
            </div>
          </div>
        </div>
      )}
    </ModalSeplag>
  );
};
export default ModalRagExercicios;
